import { useState } from 'react';
import { useData } from 'vike-react/useData';
import { usePageContext } from 'vike-react/usePageContext';
import App from 'src/App.jsx';
import Root, { queryClient } from 'src/Root';
import { seedLandingQueries } from 'src/ssr/seedLandingQueries';
import type { PageData } from './+data';

// Same render as pages/index/+Page.tsx — Vike's filesystem routing
// requires a +Page in this directory to claim the /c/:organizationSlug
// URL pattern, but the actual page within is resolved by react-router
// inside <App />. The OG metadata is what differs (see +title.ts /
// +description.ts / +image.ts / +Head.tsx siblings).
export default function Page() {
   const data = useData<PageData>();
   const pageContext = usePageContext();

   // Seed the query cache from the payload the shell already carries, before
   // <App/> renders. A lazy initializer rather than an effect: OrganizationGuard
   // must see the org on its first render, otherwise it fires the request we're
   // trying to avoid. Runs once per document — see seedLandingQueries for why
   // re-running on navigation would be wrong.
   useState(() => {
      seedLandingQueries(queryClient, pageContext.routeParams?.organizationSlug, data);
      return true;
   });

   return (
      <Root>
         <App />
      </Root>
   );
}
